/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import PulpoField from '../../pulpo_visualizer/fields';
import Clickable from '../../components/clickable/Clickable';
import Modal from '../../components/modal';
import Button from '../../components/button';
import Loading from '../../components/loading';
import closeIcon from '../../icons/close.svg';
import addIcon from '../../icons/add.svg';
import styles from './forms.module.scss';
import FormattedMessageWithClass from '../../components/formattedMessageWithClass';
import {
  docFileExtensions,
  imageFileExtensions,
  checkMultiFilesValidation,
  pptFileExtensions,
  excelFileExtensions,
  DATE_SUBMIT_FIELD_TYPES,
  TIME_FIELD_TYPES,
  EMPTY_ARRAY,
  getFieldUsesSeconds
} from '../../utils/helpers';
import {
  normalizeValue,
  getDs6LinkedSchemaFieldsMap,
  getDs6PreviewColumns,
  getDs6ColumnValue,
  getDs6ColumnTitle
} from '../../utils/ds6Helpers';


const Grid = ({
  currentField,
  answers,
  handleMutliAnswerChanged,
  repeatIndex,
  handleRemoveIndex,
  handleUpload,
  flexWrap,
  disabled,
  noTitle,
  loadData,
  showRefreshButton,
  isPublic,
  allFields,
  allAnswers,
  from,
  handleAnswerChanged,
  selectedLang,
  disableField,
  showFormErrors,
  errorListMCG,
  index,
  user,
  allDataSources,
  dataSourceValues,
  formParent,
  isFromSms,
  linkedFormAnswerDetails
}) => {
  const getFieldType = (multiFieldId) => {
    const field = currentField?.multiple_fields?.[multiFieldId];
    const validatorKey = field?.validator?.key;
    const fieldTypeKey = field?.type?.key;
    const useSeconds = getFieldUsesSeconds(field);

    if (validatorKey === 'Phone Number') {
      return 'telephone';
    }
    if (fieldTypeKey === 'date' && useSeconds) {
      return 'datetime';
    }
    if (fieldTypeKey === 'time' && useSeconds) {
      return 'time';
    }
    if (['dateWithSeconds', 'datetimeWithSeconds'].includes(fieldTypeKey)) {
      return 'datetime';
    }
    if (['timeWithSeconds', 'only_time_with_seconds'].includes(fieldTypeKey)) {
      return 'time';
    }
    if (fieldTypeKey === 'multi_level') {
      return 'dataSourceMultiLevel';
    }
    if (fieldTypeKey === 'dataSource-ds8') {
      return 'dataSourceMultiLevel';
    }
    if (fieldTypeKey === 'number' && field?.inputType?.key === 'Currency') {
      return 'currency-phone';
    }
    return fieldTypeKey;
  };


// eslint-disable-next-line consistent-return
const getWidget = (fieldData) => {
  if (fieldData?.type?.key === 'string') {
    if (fieldData?.text_aera) {
      return { type: 'textfield' };
    }
    return { type: 'charfield' };
  }
};

  const getValidators = (field, multiFieldId) => {
    const multiField = field?.multiple_fields?.[multiFieldId];
    const type = field?.multiple_fields?.[multiFieldId]?.type?.key;
    if (type === 'string') {
      return [field?.multiple_fields?.[multiFieldId]?.validator];
    }
if (type === 'number') {
      const inputTypeKey = multiField?.inputType?.key;
      if (inputTypeKey === 'Allow Only Positive Numbers') {
        return [{ type: 'positiveInput' }];
      }
      if (inputTypeKey === 'Allow Only Negative Numbers') {
        return [{ type: 'negativeInput' }];
      }
      if (inputTypeKey === 'Currency') {
        return [{ type: 'currency-phone' }];
      }
    }
    return false;
  };
   const handleFieldChange = useCallback((value, id, mId) => {
    const isDs6 = currentField?.multiple_fields?.[mId]?.type?.key === 'dataSource-ds6';
    const isCopyField = isDs6 && id !== mId && !currentField?.multiple_fields?.[id];

    if (isCopyField && handleAnswerChanged) {
      handleAnswerChanged(value, id);
    } else {
      handleMutliAnswerChanged(
        id, value, index,
        currentField?.multiple_fields?.[id]?.type || currentField?.multiple_fields?.[mId]?.type,
        mId
      );
    }
  }, [currentField, handleAnswerChanged, handleMutliAnswerChanged, index]);

  const getOtherFieldInfo = (typeInfo) => {
    let otherFieldInfo = {};
    if (
      typeInfo?.inputType?.key === 'Currency' && typeInfo?.type?.key === 'number'
    ) {
      otherFieldInfo = {
        prefix: user?.portal_airport?.airport_settings?.currency || formParent?.airport_data?.currency || '$',
        thousandSeparator: true,
        placeHolderValue: user?.portal_airport?.airport_settings?.currency ||formParent?.airport_data?.currency || '$',
        decimalDigits: 2
      };
    }
    return otherFieldInfo;
  };

   const getDurationLabel = (multiFieldId) => {
    const formatName = currentField?.multiple_fields?.[multiFieldId]?.durationFieldsMultiField?.calculationFormat?.name;
    return formatName ? ` (${formatName})` : '';
  };

  const getBaseMultiFieldTitle = (multiFieldId) => {
    const metaDataName = currentField?.multiple_fields?.[multiFieldId]?.meta_data?.[selectedLang]?.name;
    if (metaDataName) {
      return metaDataName;
    }
    return currentField?.multiple_fields?.[multiFieldId]?.title || ' ';
  };

  const getTranslation = (multiFieldId) => {
    if (currentField?.hide_repeat_title === true && repeatIndex !== 0) {
      return ' ';
    }

    const title = getBaseMultiFieldTitle(multiFieldId);
    const isDuration = currentField?.multiple_fields?.[multiFieldId]?.type?.key === 'duration';
    return isDuration ? `${title}${getDurationLabel(multiFieldId)}` : title;
  };

  const getTitle = (multiFieldId) => {
    if (currentField?.hide_repeat_title && repeatIndex !== 0) {
      return ' ';
    }

      const title = getBaseMultiFieldTitle(multiFieldId);
    const isDuration = currentField?.multiple_fields?.[multiFieldId]?.type?.key === 'duration';
    return isDuration ? `${title}${getDurationLabel(multiFieldId)}` : title;
  };

  const getMinWidth = (multiFieldId) => {
    const field = currentField?.multiple_fields?.[multiFieldId];
    if (field?.type?.key === 'multi_level' || field?.type?.key === 'dataSource-ds8') {
      return '';
    }
    if (field?.disable_edit) {
      return '150px';
    }
    return '30%';
  };

  const ds6LinkedSchemaFieldsMaps = useMemo(() => {
    const bigMap = new Map();
    const ds6Fields = Object.keys(currentField?.multiple_fields || {}).filter(
      id => currentField?.multiple_fields?.[id]?.type?.key === 'dataSource-ds6'
    );

    if (ds6Fields.length === 0) return bigMap;

    ds6Fields.forEach((multiFieldId) => {
      bigMap.set(multiFieldId, getDs6LinkedSchemaFieldsMap(currentField, multiFieldId, allDataSources));
    });

    return bigMap;
  }, [currentField, allDataSources]);

  const getLocalDs6LinkedSchemaFieldsMap = multiFieldId => ds6LinkedSchemaFieldsMaps.get(multiFieldId) || new Map();

  const ds6PreviewColumnsMap = useMemo(() => {
    const map = new Map();
    const ds6Fields = Object.keys(currentField?.multiple_fields || {}).filter(
      id => currentField?.multiple_fields?.[id]?.type?.key === 'dataSource-ds6'
    );
    ds6Fields.forEach((multiFieldId) => {
      map.set(multiFieldId, getDs6PreviewColumns(currentField, multiFieldId));
    });
    return map;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentField, allDataSources]);

  const getLocalDs6PreviewColumns = multiFieldId => ds6PreviewColumnsMap.get(multiFieldId) || [];

  const hasSelectedDs6Answer = (multiFieldId) => {
    const selectedAnswer = answers?.[multiFieldId];
    if (Array.isArray(selectedAnswer)) return selectedAnswer?.length > 0;
    if (typeof selectedAnswer === 'string') return selectedAnswer.trim().length > 0;
    if (!selectedAnswer || typeof selectedAnswer !== 'object') return false;
    const selectedId = selectedAnswer?.detailId || selectedAnswer?.detailKey || selectedAnswer?.id || '';
    const selectedValue = selectedAnswer?.value || '';
    return `${selectedId}`.trim().length > 0 || `${selectedValue}`.trim().length > 0;
  };

  const ds6SelectedEntriesMap = useMemo(() => {
    const map = new Map();
    const ds6Fields = Object.keys(currentField?.multiple_fields || {}).filter(
      id => currentField?.multiple_fields?.[id]?.type?.key === 'dataSource-ds6'
    );
    if (ds6Fields.length === 0) return map;

    ds6Fields.forEach((multiFieldId) => {
      const selectedAnswer = answers?.[multiFieldId];
      if (!selectedAnswer || Array.isArray(selectedAnswer)) {
        map.set(multiFieldId, null);
        return;
      }

      const selectedId = selectedAnswer?.detailId || selectedAnswer?.detailKey || selectedAnswer?.id || '';
      const cachedEntry = selectedAnswer?.entry_data || selectedAnswer?.entryData;
      if (cachedEntry && typeof cachedEntry === 'object') {
        map.set(multiFieldId, cachedEntry);
        return;
      }

      const linkedForm = currentField?.multiple_fields?.[multiFieldId]?.form_field_data || {};
      const linkedFormKey = normalizeValue(linkedForm.key || linkedForm.form_key);

      const isEntryMatch = (entry) => {
        const idMatch = [entry?.key, entry?.id, entry?.detailId, entry?.detailKey]
          .filter(v => v !== undefined && v !== null)
          .some(v => String(v) === String(selectedId));
        if (!idMatch) return false;
        if (linkedFormKey) {
          const entryFormKey = normalizeValue(
            entry?.form_key || entry?.form?.form_key || entry?.form_version?.form?.form_key
          );
          if (entryFormKey && entryFormKey !== linkedFormKey) return false;
        }
        return true;
      };

      const linkedRows = Array.isArray(linkedFormAnswerDetails?.[multiFieldId]) ? linkedFormAnswerDetails[multiFieldId] : [];
      if (linkedRows?.length) {
        const found = linkedRows.find(isEntryMatch);
        if (found) {
          map.set(multiFieldId, found);
          return;
        }
      }

      if (selectedId) {
        const directEntry = linkedFormAnswerDetails?.[String(selectedId)];
        if (directEntry && typeof directEntry === 'object' && !Array.isArray(directEntry) && isEntryMatch(directEntry)) {
          map.set(multiFieldId, directEntry);
          return;
        }
      }
      map.set(multiFieldId, null);
    });
    return map;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [answers, linkedFormAnswerDetails, currentField, allDataSources]);

  const getSelectedDs6Entry = multiFieldId => ds6SelectedEntriesMap.get(multiFieldId) ?? null;

  const getDs6ColumnTitleLocal = (multiFieldId, columnId, columnConfig) => getDs6ColumnTitle(
    multiFieldId,
    columnId,
    columnConfig,
    currentField,
    allDataSources,
    getLocalDs6LinkedSchemaFieldsMap(multiFieldId)
  );

  const getDs6ColumnValueLocal = (entry, columnId, multiFieldId) => getDs6ColumnValue({
    entry,
    columnId,
    multiFieldId,
    currentField,
    allDataSources,
    renderInfoParams: { selectedLang, user },
    linkedFieldsMap: getLocalDs6LinkedSchemaFieldsMap(multiFieldId)
  });

  const renderDs6PreviewFields = (multiFieldId) => {
    const previewColumns = getLocalDs6PreviewColumns(multiFieldId);
    if (!previewColumns?.length || !hasSelectedDs6Answer(multiFieldId) || isPublic) return null;

    const selectedEntry = getSelectedDs6Entry(multiFieldId);

    return previewColumns.map((column, colIndex) => {
      const title = getDs6ColumnTitleLocal(multiFieldId, column?.id, column?.config);
      return (
        <div
          key={`${currentField?.id}-${multiFieldId}-${column?.id}`}
          style={{ marginTop: '10px', marginLeft: colIndex === 0 ? '20px' : '0', minWidth: getMinWidth(multiFieldId) }}
        >
          <PulpoField
            id={`${multiFieldId}-${column?.id}`}
            type="string"
            title={title}
            translation={title}
            disabled
            handleValueChange={() => {}}
            answer={getDs6ColumnValueLocal(selectedEntry, column?.id, multiFieldId)}
            showFieldErrors={false}
            handleFieldErrorChanged={() => {}}
            customField
            fieldMcgId={currentField?.id}
          />
        </div>
      );
    });
  };


  return (
    <div className={styles.multiGrid} style={flexWrap ? {
      flexWrap: 'wrap',
      ...((Object.keys(currentField?.multiple_fields || {}).length > 3 && { width: '940px' }) || {})
    } : {}}
    >
      {repeatIndex === 0 && (
        <div className={styles.multiColumnTitle}>
          <FormattedMessageWithClass
            className={`${styles.grid_title} ${from === 'Badging' && styles.attachmentsTitle}`}
            tagName="h3"
            id="multi_column_grid.title"
            defaultMessage={(selectedLang && selectedLang !== '' && currentField?.meta_data && currentField?.meta_data?.[selectedLang]
              && currentField?.meta_data?.[selectedLang]?.name) ? currentField?.meta_data?.[selectedLang]?.name : currentField.title}
          />
          {showRefreshButton && (
            <h5 onClick={() => loadData()} className={styles.grid_link}>Refresh Data</h5>
          )}
        </div>)
      }
      <div className={styles.fields}>
        {currentField?.multiple_fields && Object.keys(currentField?.multiple_fields)?.map(multiFieldId => (
          <React.Fragment key={multiFieldId}>
            {(currentField?.multiple_fields?.[multiFieldId]?.conditional_field?.length > 0
              ? currentField?.multiple_fields?.[multiFieldId]?.conditional_values?.includes(
                answers?.[currentField?.multiple_fields?.[multiFieldId]?.conditional_field]
              ) : true)
              && currentField?.multiple_fields?.[multiFieldId]?.type?.key !== 'attachments'
              && !(isPublic && currentField?.multiple_fields?.[multiFieldId]?.type?.key === 'dataSource-ds6')
              && currentField?.multiple_fields?.[multiFieldId]?.type && (
                <React.Fragment key={`${currentField?.id}-${multiFieldId}`}>
                  <div style={{
                    marginTop: '10px',
                    minWidth: currentField?.multiple_fields?.[multiFieldId]?.type?.key === 'multi_level' ? ''
                      : currentField?.multiple_fields?.[multiFieldId]?.disable_edit ? '150px' : getMinWidth(multiFieldId)
                  }}>
                    {currentField?.multiple_fields?.[multiFieldId]?.disable_edit ? (
                      <>
                        {index === 0
                          && <span className={styles.titlelabel}>{currentField?.multiple_fields?.[multiFieldId]?.title}</span>}
                        <h5 className={(index === 0 ? styles.lable0 : (currentField?.required ? styles.lables : styles.reqLables))}>
                          {answers?.[multiFieldId]}
                        </h5>
                      </>
                    )
                      : (
                        <div
                          style={{
                            display: currentField?.multiple_fields?.[multiFieldId]?.codeValues ? 'flex' : ''
                          }}
                        >
                          {currentField?.multiple_fields?.[multiFieldId]?.type?.key === 'dataSource-ds8' && (
                            <PulpoField
                              levels={{
                                level_1: {
                                  title: `${!!currentField?.hide_repeat_title && repeatIndex !== 0 ? ' '
                                    : currentField?.multiple_fields?.[multiFieldId]?.levels?.level_1?.title || 'Level 1'}`
                                },
                                level_2: {
                                  title: `${!!currentField?.hide_repeat_title && repeatIndex !== 0 ? ' '
                                    : currentField?.multiple_fields?.[multiFieldId]?.levels?.level_2?.title || 'Level 2'}`
                                },
                                level_3: {
                                  title: `${!!currentField?.hide_repeat_title && repeatIndex !== 0 ? ' '
                                    : currentField?.multiple_fields?.[multiFieldId]?.levels?.level_3?.title || 'Level 3'}`
                                }
                              }}
                              key={`${currentField?.id}-${multiFieldId}`}
                              id={multiFieldId}
                              // eslint-disable-next-line no-nested-ternary
                              type={'dataSourceMultiLevel'}
                              values={typeof currentField?.multiple_fields?.[multiFieldId]?.values === 'object'
                                ? Object.values(currentField?.multiple_fields?.[multiFieldId]?.values).map(item => ({ ...item, name: item.title }))
                                : currentField?.multiple_fields?.[multiFieldId]?.values
                              }
                              title={getTitle(multiFieldId)}
                              hideMandatorySign={!getTitle(multiFieldId).trim().length > 0}
                              translation={getTranslation(multiFieldId)}
                              handleValueChange={(value, id) => {
                                handleMutliAnswerChanged(id, value, index, currentField?.multiple_fields?.[multiFieldId]?.type, multiFieldId);
                              }}
                              answer={answers?.[multiFieldId]}
                              isRequired={currentField?.required || currentField?.multiple_fields?.[multiFieldId]?.mandatory_multi_field}
                              handleFieldErrorChanged={() => { }}
                              disabled={currentField?.multiple_fields?.[multiFieldId]?.disable_edit || disabled}
                              fromMultiGrid
                              fields={currentField?.multiple_fields}
                              allFields={allFields}
                              allAnswers={allAnswers}
                              durationAnswers={answers}
                              handleAnswerChanged={handleAnswerChanged}
                              answers={answers}
                              noDefault
                              settings={
                                (currentField?.multiple_fields?.[multiFieldId]?.type?.key === 'date'
                                  && currentField?.multiple_fields?.[multiFieldId]?.settings)
                                || (currentField?.settings || {})}
                              multiFieldId={currentField}
                              repeatIndex={repeatIndex}
                              calculationField={answers?.[multiFieldId]}
                              multifield
                              placeHolder={currentField?.multiple_fields?.[multiFieldId]?.validator?.key === 'Email' ? 'name@email.com' : ''}
                              showFieldErrors={showFormErrors}
                              customError={errorListMCG?.[currentField?.id]?.[index]?.[multiFieldId]
                                ? errorListMCG?.[currentField?.id]?.[index]?.[multiFieldId] : ''}
                              dataSourceID={currentField?.multiple_fields?.[multiFieldId]?.type?.key === 'dataSource-ds8' ? 'ds8' : undefined}
                              allDataSources={allDataSources}
                              dataSourceValues={dataSourceValues}
                              global_location={currentField?.multiple_fields?.[multiFieldId]?.globalLocation}
                              customStyles={{}}
                              sendWithSecond={getFieldUsesSeconds(currentField?.multiple_fields?.[multiFieldId])}
                            />
                          )}
                          {currentField?.multiple_fields?.[multiFieldId]?.type?.key === 'dataSource-ds6' && !isPublic && (
                            <PulpoField
                              key={`${currentField?.id}-${multiFieldId}`}
                              id={multiFieldId}
                              type="dataSource"
                              title={getTitle(multiFieldId)}
                              translation={getTranslation(multiFieldId)}
                              handleValueChange={(value, id) => {
                                handleFieldChange(value, id, multiFieldId);
                              }}
                              answer={answers?.[multiFieldId]}
                              isRequired={currentField?.required || currentField?.multiple_fields?.[multiFieldId]?.mandatory_multi_field}
                              handleFieldErrorChanged={() => { }}
                              disabled={currentField?.multiple_fields?.[multiFieldId]?.disable_edit || disabled}
                              fromMultiGrid
                              allFields={allFields}
                              handleAnswerChanged={handleAnswerChanged}
                              answers={answers}
                              showFieldErrors={showFormErrors}
                              customError={errorListMCG?.[currentField?.id]?.[index]?.[multiFieldId] || ''}
                              dataSourceID={currentField?.multiple_fields?.[multiFieldId]?.type?.key === 'dataSource-ds6' ? 'ds6' : undefined}
                              filters={{
                                id: currentField?.multiple_fields?.[multiFieldId]?.form_field_data?.id,
                                field_id: currentField?.multiple_fields?.[multiFieldId]?.customFields?.value || '',
                                form_name: currentField?.multiple_fields?.[multiFieldId]?.form_field_data?.name,
                                field_name: currentField?.multiple_fields?.[multiFieldId]?.customFields?.label
                                  || currentField?.multiple_fields?.[multiFieldId]?.customFields?.title || '',
                                form_key: currentField?.multiple_fields?.[multiFieldId]?.form_field_data?.key,
                                show_values: currentField?.multiple_fields?.[multiFieldId]?.form_field_data?.show_values
                                  || { value: 'table', label: 'Show values in a table view' }
                              }}
                            />
                          )}
                          {currentField?.multiple_fields?.[multiFieldId]?.type?.key !== 'dataSource-ds8'
                            && currentField?.multiple_fields?.[multiFieldId]?.type?.key !== 'dataSource-ds6' && (
                            <PulpoField
                              levels={{
                                level_0: {
                                  title: `${!!currentField?.hide_repeat_title && repeatIndex !== 0 ? ' '
                                    : `${currentField?.multiple_fields?.[multiFieldId]?.title}` || ''}`
                                },
                                level_1: {
                                  title: `${!!currentField?.hide_repeat_title && repeatIndex !== 0 ? ' '
                                    : `${currentField?.multiple_fields?.[multiFieldId]?.title} 1` || ''}`
                                },
                                level_2: {
                                  title: `${!!currentField?.hide_repeat_title && repeatIndex !== 0 ? ' '
                                    : `${currentField?.multiple_fields?.[multiFieldId]?.title} 2` || ''}`
                                }
                              }}
                              key={`${currentField?.id}-${multiFieldId}`}
                              id={multiFieldId}
                              type={getFieldType(multiFieldId)}
                              values={typeof currentField?.multiple_fields?.[multiFieldId]?.values === 'object'
                                ? Object.values(currentField?.multiple_fields?.[multiFieldId]?.values).map(item => ({ ...item, name: item.title }))
                                : currentField?.multiple_fields?.[multiFieldId]?.values
                              }
                              hideMandatorySign={!getTitle(multiFieldId).trim().length}
                              title={getTitle(multiFieldId)}
                              translation={getTranslation(multiFieldId)}
                              handleValueChange={(value, id) => handleFieldChange(
                                value, id, multiFieldId
                              )}
                              answer={answers?.[multiFieldId]}
                              isRequired={currentField?.required || currentField?.multiple_fields?.[multiFieldId]?.mandatory_multi_field}
                              handleFieldErrorChanged={() => { }}
                              onlyTime={['time', 'only_time', 'only_time_with_seconds'].includes(
                              currentField?.multiple_fields?.[multiFieldId]?.type?.key
                              )}
                              sendWithSecond={getFieldUsesSeconds(currentField?.multiple_fields?.[multiFieldId])}
                              disabled={currentField?.multiple_fields?.[multiFieldId]?.disable_edit || disabled}
                              fromMultiGrid
                              fields={currentField?.multiple_fields}
                              allFields={allFields}
                              allAnswers={allAnswers}
                              durationAnswers={answers}
                              handleAnswerChanged={handleAnswerChanged}
                              answers={answers}
                              noDefault={
                                 isFromSms || !(
                                  currentField?.multiple_fields?.[multiFieldId]?.default
                                  || currentField?.multiple_fields?.[multiFieldId]?.type?.default
                                )
                              }
                              settings={
                                (DATE_SUBMIT_FIELD_TYPES.includes(currentField?.multiple_fields?.[multiFieldId]?.type?.key)
                                  && currentField?.multiple_fields?.[multiFieldId]?.settings)
                                || (TIME_FIELD_TYPES.includes(currentField?.multiple_fields?.[multiFieldId]?.type?.key)
                                  && currentField?.multiple_fields?.[multiFieldId]?.settings)
                                || (currentField?.multiple_fields?.[multiFieldId]?.type?.key === 'number'
                                  && currentField?.multiple_fields?.[multiFieldId]?.positive_input
                                  ? { positiveNumbers: true }
                                  : currentField?.settings || {})
                              }
                              multiFieldId={currentField}
                              repeatIndex={repeatIndex}
                              calculationField={answers?.[multiFieldId]}
                              multifield
                              widget={getWidget(currentField?.multiple_fields?.[multiFieldId])}
                              placeHolder={currentField?.multiple_fields?.[multiFieldId]?.validator?.key === 'Email' ? 'name@email.com' : ''}
                              showFieldErrors={showFormErrors || errorListMCG?.[currentField?.id]?.[index]?.[multiFieldId]}
                              customError={errorListMCG?.[currentField?.id]?.[index]?.[multiFieldId]
                                ? errorListMCG?.[currentField?.id]?.[index]?.[multiFieldId] : ''}
                              forFormModule={currentField?.multiple_fields?.[multiFieldId]?.type?.key === 'multi_level'}
                              multiFields={currentField?.multiple_fields}
                              popoverMultiEmail={currentField?.multiple_fields?.[multiFieldId]?.validator?.multiple_email}
                              validators={getValidators(currentField, multiFieldId)}
                              {...getOtherFieldInfo(currentField?.multiple_fields?.[multiFieldId])}
                            />
                          )}
                          {currentField?.multiple_fields?.[multiFieldId]?.type?.key === 'select'
                            && currentField?.multiple_fields?.[multiFieldId]?.codeValues && (
                              <PulpoField
                                key={currentField.id}
                                id={currentField.id}
                                type="string"
                                title={
                                  currentField?.multiple_fields?.[multiFieldId]?.textForCodedValues
                                }
                                disabled
                                handleValueChange={(value, id, type, multiFieldID) => handleMutliAnswerChanged(id, value, index, type, multiFieldID)}
                                answer={
                                  answers
                                  && currentField?.multiple_fields?.[multiFieldId]?.values?.find(
                                    i => i.key === answers[multiFieldId]
                                  )?.coded_value
                                }
                                showFieldErrors={showFormErrors}
                                handleFieldErrorChanged={() => { }}
                              />
                            )}
                        </div>
                      )
                    }
                  </div>
                  {currentField?.multiple_fields?.[multiFieldId]?.type?.key === 'dataSource-ds6' && (
                    renderDs6PreviewFields(multiFieldId)
                  )}
                </React.Fragment>
              )}
            {currentField?.multiple_fields?.[multiFieldId]?.type?.key === 'attachments' && (
              <div className={((from === 'Badging' && (currentField?.required ? styles.badgeAttchementCard
                : (index === 0 && styles.badgeAttchementCard))))}>
                {currentField?.hide_repeat_title === true && repeatIndex !== 0 ? (
                  ''
                ) : (
                  <span className={styles.attachmentsLabel}>
                    {currentField?.multiple_fields?.[multiFieldId]?.title}
                  </span>
                )}
                <Clickable className={styles.uploadFile}
                  onClick={disabled ? () => disableField() : () => handleUpload(multiFieldId)}
                >
                  <FormattedMessage
                    id="flow_grid.upload"
                    defaultMessage="Upload"
                  />
                </Clickable>
                {currentField?.multiple_fields?.[multiFieldId]?.mandatory_multi_field
                  && (!answers?.[multiFieldId] || Array.isArray(answers?.[multiFieldId]) && answers?.[multiFieldId].length === 0)
                  && showFormErrors
                  && (
                    <small style={{ color: 'red' }}>
                      <FormattedMessage id="pulpoforms.errors.not_blank"
                        defaultMessage="This field cannot be empty"
                      />
                    </small>
                  )}
              </div>
            )}
          </React.Fragment>))}
        {!noTitle && !currentField?.settings?.hideRemoveButton && (
          <div>
            {currentField?.repeat_field && repeatIndex !== 0 && (
              <Clickable
                onClick={() => handleRemoveIndex(repeatIndex)}
              >
                <img src={closeIcon} alt="X" />
              </Clickable>
            )}
          </div>)}
      </div>
    </div>
  );
};
class MultiColumnGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uploadAttachment: false,
      loadingStatus: false,
      attachedFiles: []
    };
    this.mcgGDSValues = {};
  }

  handleMutliAnswerChanged = (section, value, index, type, multiField) => {
    const { currentField, handleAnswerChanged, answers, handleFieldErrorChanged, isPublic } = this.props;
    let previousAnswer = answers?.[currentField?.id];
    let field = {};
    let previousGDSValues = this.mcgGDSValues;
    if (multiField?.multiFieldType === 'duration') {
      const prevEntry = Array.isArray(previousAnswer) && previousAnswer.length > 0
        ? previousAnswer[0]
        : {};

      const updatedEntry = {
        ...prevEntry,
        [section]: value
      };

      field = [updatedEntry];
    } else if (multiField?.multiFieldType !== 'duration') {
    if (index >= 0) {
      let prevIndexAnswer = { ...(answers?.[currentField?.id]?.[index] || {}) };
      if (Object.keys(prevIndexAnswer)?.length === 0 && type?.key === 'dataSource-ds8') {
        prevIndexAnswer = { ...(this.mcgGDSValues?.[currentField?.id]?.[index] || {}) };
      }
      previousAnswer = previousAnswer || [];
      field = [
        ...previousAnswer
      ];
      field[index] = {
        ...prevIndexAnswer,
        [section]: value
      };
    } else {
      field = {
        ...previousAnswer,
        [section]: value
      };
    }
    const handleConditionalField = () => {
      field = field.map((eachRow) => {
        const listOfFieldIds = Object.keys(eachRow || {});
        const updatedRow = { ...eachRow };
        listOfFieldIds.forEach((eachId) => {
          const conditionalField = currentField?.multiple_fields?.[eachId]?.conditional_field || '';
          const conditionalValues = currentField?.multiple_fields?.[eachId]?.conditional_values || [];

          if (conditionalField.length > 0 && !eachRow[conditionalField]) {
            updatedRow[eachId] = '';
          }

          if (conditionalField.length > 0 && eachRow[conditionalField] && !conditionalValues.includes(eachRow[conditionalField])) {
            updatedRow[eachId] = '';
          }
        });
        return updatedRow;
      });


      return field;
    };

    handleConditionalField();
    let temp = Object.keys(currentField?.multiple_fields || {}).filter(item => Object.keys(currentField?.multiple_fields?.[item] ?? {})?.length > 0
    && !currentField?.multiple_fields?.[item]?.disable_edit
    && !(isPublic && currentField?.multiple_fields?.[item]?.type?.key === 'dataSource-ds6'));
    if (currentField?.id) {
      if (Array.isArray(field) && field?.every(item => temp?.every((ele) => {
        if ((currentField?.multiple_fields?.[ele]?.conditional_field
          && !currentField?.multiple_fields?.[ele]?.conditional_values?.includes(item?.[currentField?.multiple_fields?.[ele]?.conditional_field]))) {
          return true;
        }
          return item[ele];
         }))) {
        handleFieldErrorChanged(currentField?.id, false);
      } else {
        handleFieldErrorChanged(currentField?.id, !!currentField?.required);
      }
    }
    }
    if (index >= 0 && type?.key === 'dataSource-ds8' && typeof value === 'object') {
      const keys = Object.keys(value);
      if (keys?.length === 1 && keys[0] === 'level_0') {
        const newFields = field.map((item) => {
          const hasFieldId = Object.prototype.hasOwnProperty.call(item, multiField);

          const hasMultipleLevelKeys = (fv) => {
            if (fv && fv[multiField] && typeof fv[multiField] === 'object') {
              const gdsKeys = Object.keys(fv[multiField]);
              return gdsKeys.length > 1;
            }
            return false;
          };
          const isExisiting = hasMultipleLevelKeys(item);

          const isValidField3 = hasFieldId
            && JSON.stringify(item[multiField]) === JSON.stringify(value);

          if (!isValidField3 && !isExisiting) {
            return {
              ...item,
              [multiField]: value
            };
          }

          return item;
        });
        previousGDSValues = {
          ...previousGDSValues,
          [currentField?.id]: newFields
        };
        this.mcgGDSValues = previousGDSValues;
        handleAnswerChanged(newFields, currentField?.id, type, multiField);
      } else {
        handleAnswerChanged(field, currentField?.id, type, multiField);
      }
    } else {
      handleAnswerChanged(field, currentField?.id, type, multiField);
    }
  }

  handleDrop = (files) => {
    const { from } = this.props;
    const file = from === 'Badging'? Object.values(files || {}) : files;

    if (!checkMultiFilesValidation(file, `${imageFileExtensions}, ${docFileExtensions}, ${pptFileExtensions}, ${excelFileExtensions}`)) return;
    const { attachedFiles } = this.state;
    const previousFiles = attachedFiles || [];
    this.setState({
      attachedFiles: [
        ...file,
        ...previousFiles
      ]
    });
  };

  handleRemoveImage = (e) => {
    const { attachedFiles } = this.state;
    const previousFiles = attachedFiles || [];
    let photos = [];
    if (!e.id) {
      photos = previousFiles.filter(photo => photo !== e);
    }

    if (e?.id) {
      photos = previousFiles.filter(photo => photo?.id !== e.id);
    }

    this.setState({
      attachedFiles: [
        ...photos
      ]
    });
  }

  handleAdd = () => {
    const { answers, currentField, handleAnswerChanged, handleFieldErrorChanged } = this.props;
    const lastObj = answers?.[currentField?.id]?.[answers?.[currentField?.id]?.length - 1] || {};
    let temp;
    if (currentField?.type==='multi_field' && currentField?.fixed_Rows
       && currentField?.repeat_field && Object.keys(currentField?.settings?.multiFields_default_values || {})?.length>0) {
        temp = currentField?.settings?.multiFields_default_values?.[`rowField_${answers?.[currentField?.id]?.length}`];
    }
    if (lastObj && Object.keys(lastObj)?.length !== 0) {
      handleAnswerChanged([
        ...answers?.[currentField?.id],
        temp || {}
      ], currentField?.id);
      handleFieldErrorChanged(currentField?.id, true);
    }
  }

  handleRemoveIndex = (currentIndex) => {
    const { answers, currentField, handleAnswerChanged, handleFieldErrorChanged, isPublic } = this.props;
    const answer = answers?.[currentField?.id] || [];
    const remainingAnswers = answer?.filter((obj, index) => currentIndex !== index);
    handleAnswerChanged([...remainingAnswers], currentField?.id);
    let temp = Object.keys(currentField?.multiple_fields || {}).filter((item) => {
      const hasConfig = Object.keys(currentField?.multiple_fields?.[item] ?? {}).length > 0;
      const isMandatory = currentField?.multiple_fields?.[item]?.mandatory_multi_field === true;
      if (isPublic && currentField?.multiple_fields?.[item]?.type?.key === 'dataSource-ds6') {
        return false;
      }
      return hasConfig && isMandatory;
    });
    if (currentField?.id) {
      if (remainingAnswers?.every(item => temp?.every((ele) => {
        if ((currentField?.multiple_fields?.[ele]?.conditional_field
          && !currentField?.multiple_fields?.[ele]?.conditional_values?.includes(item?.[currentField?.multiple_fields?.[ele]?.conditional_field]))) {
          return true;
        }
          return item?.[ele];
         }))) {
        handleFieldErrorChanged(currentField?.id, false);
      } else {
        handleFieldErrorChanged(currentField?.id, true);
      }
    }
  }

  handleUpload = (multiFieldId, repeatIndex) => {
    const { answers, currentField } = this.props;
    let previousAttachments = answers?.[currentField?.id]?.multiFieldId;
    if (repeatIndex >= 0) {
      previousAttachments = answers?.[currentField?.id]?.[repeatIndex]?.[multiFieldId];
    }
    this.setState({
      uploadAttachment: true,
      selectedField: multiFieldId,
      selectedRepeatIndex: repeatIndex,
      attachedFiles: previousAttachments || []
    });
  }

  disableField = () => {
    this.setState({ uploadAttachment: false });
  }

  handleSaveUpload = async (save) => {
    const { attachedFiles, selectedRepeatIndex, selectedField } = this.state;
    const { handleUploadAttachments } = this.props;
    if (save) {
      this.setState({ loadingStatus: true });
      const newAttachments = attachedFiles?.filter(attach => (!attach?.attachmentUploadId && !attach?.id)) || [];
      const attachmentIds = await handleUploadAttachments(newAttachments);
      for (let index = 0; index < attachedFiles.length; index++) {
        if (!attachedFiles[index]?.attachmentUploadId && !attachedFiles[index]?.id) {
          attachedFiles[index].attachmentUploadId = attachmentIds[index];
        }
      }
      this.handleMutliAnswerChanged(
        selectedField,
        attachedFiles,
        selectedRepeatIndex
      );
      this.setState({ loadingStatus: false });
    }
    this.setState({
      uploadAttachment: false,
      selectedField: undefined,
      selectedRepeatIndex: undefined,
      attachedFiles: []
    });
  }

  render() {
    const {
      currentField,
      answers,
      flexWrap,
      disabled,
      loadData,
      allFields,
      handleAnswerChanged,
      selectedLang,
      showFormErrors,
      from,
      user,
      errorListMCG,
      isFromSms,
      allDataSources,
      dataSourceValues,
      formParent,
      linkedFormAnswerDetails,
      isPublic
    } = this.props;

    const { uploadAttachment, attachedFiles, loadingStatus } = this.state;
    return (
      <>
      <Loading loadingStatus={loadingStatus} />
      <div style={from === 'Badging' ? {} :{ overflow: 'auto', width: '97%' }}>
      <Grid
        currentField={currentField}
        handleMutliAnswerChanged={(id, value, index, type, multiField) => this.handleMutliAnswerChanged(
          id, value, index, type, multiField
        )}
        handleDrop={(dropped, id) => this.handleDrop(dropped, id, 0)}
        answers={answers?.[currentField?.id]?.[0]}
        repeatIndex={0}
        handleAnswerChanged={handleAnswerChanged}
        handleRemoveIndex={this.handleRemoveIndex}
        handleUpload={multiFieldId => this.handleUpload(multiFieldId, 0)}
        flexWrap={flexWrap}
        disabled={disabled}
        noTitle={false}
        showRefreshButton={currentField.show_refresh_button}
        loadData={loadData}
        allFields={allFields}
        allAnswers={answers}
        from={from}
        selectedLang={selectedLang}
        disableField={this.disableField}
        showFormErrors={showFormErrors}
        errorListMCG={errorListMCG}
        index={0}
        user={user}
        allDataSources={allDataSources}
        dataSourceValues={dataSourceValues}
        formParent={formParent}
        isFromSms={isFromSms}
        linkedFormAnswerDetails={linkedFormAnswerDetails}
        isPublic={isPublic}
      />

      {currentField?.repeat_field && (
        <>
        {answers?.[currentField?.id]?.length > 1
          && Array.isArray(answers?.[currentField?.id])
          && answers?.[currentField?.id]?.map((key, index) => {
            const rowPosition = index;
            return (
            <React.Fragment key={`${currentField?.id}-${rowPosition}`}>
              {index !== 0 && (
                <Grid
                  currentField={currentField}
                  handleMutliAnswerChanged={(id, value, i, type, multiField) => this.handleMutliAnswerChanged(
                    id, value, i, type, multiField
                  )}
                  handleDrop={(dropped, id) => this.handleDrop(dropped, id, index)}
                  answers={answers?.[currentField?.id]?.[index]}
                  repeatIndex={index}
                  handleRemoveIndex={this.handleRemoveIndex}
                  handleUpload={multiFieldId => this.handleUpload(multiFieldId, index)}
                  flexWrap={flexWrap}
                  disabled={disabled}
                  noTitle={currentField.dont_show_add_row}
                  showRefreshButton={currentField.show_refresh_button}
                  allFields={allFields}
                  from={from}
                  allAnswers={answers}
                  durationAnswers={answers?.[currentField?.id]?.[index]}
                  handleAnswerChanged={handleAnswerChanged}
                  showFormErrors={showFormErrors}
                  errorListMCG={errorListMCG}
                  index={index}
                  user={user}
                  allDataSources={allDataSources}
                  dataSourceValues={dataSourceValues}
                  formParent={formParent}
                  selectedLang={selectedLang}
                  disableField={this.disableField}
                  isFromSms={isFromSms}
                  linkedFormAnswerDetails={linkedFormAnswerDetails}
                  isPublic={isPublic}
                />
              )}
            </React.Fragment>
            );
          })}
          {(!currentField.dont_show_add_row)
          && (!currentField?.fixed_Rows || parseInt(currentField?.fixed_Rows, 10)>(answers?.[currentField?.id]?.length || 0))&&(
          <Clickable
            className={`${styles.addlink} ${styles.addLink}`}
            onClick={() => this.handleAdd()}
          >
            <FormattedMessage
              id="pulpofield.string.add_more"
              defaultMessage="+ Add more"
            />
          </Clickable>
          )}
        </>
      )}
      </div>
      <Modal
        showIn={uploadAttachment}
        onClose={() => this.handleSaveUpload()}
        width="554px"
        minHeight="auto"
      >
        <div className={styles.headder}>
          <div className={`${styles.subHeading} ${styles.inspTitle}`}>
            <h5 className={styles.h5}>
              <FormattedMessage
                id="flow.grid.upload"
                defaultMessage="Upload"
              />
            </h5>
          </div>
          <label htmlFor="files" className={`${styles.btn} ${styles.closeIcon}`}>
          <img src={addIcon} alt="Add" />
          </label>
          <input
            accept=".doc,.docx,.pdf,.odt,.ods,.odp,.jpg,.jpeg,.gif,.png,.svg,.xlr,.xls,.xlsx,.csv,.pps,.ppt,.pptx"
            id="files"
            style={{ visibility: 'hidden', position: 'absolute' }} type="file"
            onChange={e => this.handleDrop(e.target.files)}
            multiple
          />
        </div>
        <div>
          {attachedFiles?.map(file => (
            <div
              key={file?.attachmentUploadId || file?.id || file?.name || file?.file_name}
              className={styles.fileNames}
            >
              <span>
                {file?.file_name || file?.name}
                <button
                  type="submit"
                  onClick={() => this.handleRemoveImage(file)}
                >
                  <img src={closeIcon} alt="X" />
                </button>
              </span>
            </div>
          ))}
        </div>
        <div className={styles.footer1}>
          <Button
            className={styles.closeBtn}
            onClick={() => this.handleSaveUpload()}
            translationID="todo.newTask.cancel"
            defaultText="Cancel" action="tertiary"
          />
          <Button
            className={styles.saveBtn}
            onClick={() => this.handleSaveUpload('save')}
            translationID="todo.newTask.save"
            defaultText="Save" action="secondary"
          />
        </div>
      </Modal>
      </>
    );
  }
}

Grid.propTypes = {
  currentField: PropTypes.shape({}),
  answers: PropTypes.arrayOf(PropTypes.shape({})),
  handleMutliAnswerChanged: PropTypes.func,
  repeatIndex: PropTypes.number,
  handleRemoveIndex: PropTypes.func,
  handleUpload: PropTypes.func,
  flexWrap: PropTypes.bool,
  disabled: PropTypes.bool,
  noTitle: PropTypes.bool,
  loadData: PropTypes.func,
  showRefreshButton: PropTypes.bool,
  allFields: PropTypes.arrayOf(PropTypes.shape({})),
  allAnswers: PropTypes.shape({}),
  from: PropTypes.string,
  handleAnswerChanged: PropTypes.func,
  selectedLang: PropTypes.string,
  disableField: PropTypes.bool,
  showFormErrors: PropTypes.bool,
  errorListMCG: PropTypes.shape({}),
  index: PropTypes.number,
  user: PropTypes.shape({}),
  allDataSources: PropTypes.arrayOf(PropTypes.shape({})),
  dataSourceValues: PropTypes.shape({}),
  formParent: PropTypes.shape({}),
  isFromSms: PropTypes.bool,
  linkedFormAnswerDetails: PropTypes.arrayOf(PropTypes.shape({})),
  isPublic: PropTypes.bool
};

Grid.defaultProps = {
  currentField: {},
  answers: EMPTY_ARRAY,
  handleMutliAnswerChanged: () => {},
  repeatIndex: 0,
  handleRemoveIndex: () => {},
  handleUpload: () => {},
  flexWrap: false,
  disabled: false,
  noTitle: false,
  loadData: () => {},
  showRefreshButton: false,
  allFields: [],
  allAnswers: {},
  from: '',
  handleAnswerChanged: () => {},
  selectedLang: 'en',
  disableField: false,
  showFormErrors: false,
  errorListMCG: {},
  index: 0,
  user: {},
  allDataSources: EMPTY_ARRAY,
  dataSourceValues: {},
  formParent: {},
  isFromSms: false,
  linkedFormAnswerDetails: EMPTY_ARRAY,
  isPublic: false
};

MultiColumnGrid.propTypes = {
  currentField: PropTypes.shape({}).isRequired
};

export default MultiColumnGrid;
